import _ from 'underscore';
import { i18nMap } from './i18n-map';

const Frequency = _.invert(i18nMap.Frequencies);

const DefaultTimeZone = {
  'en-US': 'Pacific Standard Time',
  'en-GB': 'Greenwich Standard Time',
  'fr-FR': 'Central European Standard Time',
  'de-DE': 'Central European Standard Time',
  'nl-NL': 'Central European Standard Time',
  'es-ES': 'Central European Standard Time',
  'it-IT': 'Central European Standard Time',
  'de-CH': 'Central European Standard Time',
  'it-CH': 'Central European Standard Time',
  'fr-CH': 'Central European Standard Time',
  'en-CH': 'Central European Standard Time',
  'de-AT': 'Central European Standard Time',
  'sv-SE': 'Central European Standard Time',
  'fr-BE': 'Central European Standard Time',
  'en-CA': 'Pacific Standard Time',
  'en-AU': 'E. Australia Standard Time',
  'en-IN': 'India Standard Time',
  'ja-JP': 'Pacific Standard Time',
  'da-DK': 'Pacific Standard Time',
  'fi-FI': 'Pacific Standard Time',
  'en-IE': 'Pacific Standard Time',
  'nb-NO': 'Pacific Standard Time',
  'pl-PL': 'Pacific Standard Time',
  'pt-PT': 'Pacific Standard Time',
  'tr-TR': 'Pacific Standard Time',
  'el-GR': 'Pacific Standard Time',
  'en-ZA': 'Pacific Standard Time',
  'fr-AD': 'Pacific Standard Time',
  'bg-BG': 'Pacific Standard Time',
  'en-CY': 'Pacific Standard Time',
  'el-CY': 'Pacific Standard Time',
  'cs-CZ': 'Pacific Standard Time',
  'et-EE': 'Pacific Standard Time',
  'en-GR': 'Pacific Standard Time',
  'hr-HR': 'Pacific Standard Time',
  'en-HU': 'Pacific Standard Time',
  'hu-HU': 'Pacific Standard Time',
  'de-LI': 'Pacific Standard Time',
  'it-LT': 'Pacific Standard Time',
  'fr-LU': 'Pacific Standard Time',
  'de-LU': 'Pacific Standard Time',
  'lv-LV': 'Pacific Standard Time',
  'fr-MC': 'Pacific Standard Time',
  'mt-MT': 'Pacific Standard Time',
  'ro-RO': 'Pacific Standard Time',
  'sk-SK': 'Pacific Standard Time',
  'en-SK': 'Pacific Standard Time',
  'sl-SI': 'Pacific Standard Time',
  'it-SM': 'Pacific Standard Time',
  'en-SM': 'Pacific Standard Time',
  'it-VA': 'Pacific Standard Time',
  'lt-LT': 'Pacific Standard Time',
  'en-AW': 'Atlantic Standard Time',
  'en-BS': 'Eastern Standard Time',
  'es-BO': 'Atlantic Standard Time',
  'en-KY': 'Eastern Standard Time',
  'es-CR': 'Central Standard Time',
  'en-DM': 'Atlantic Standard Time',
  'es-DO': 'Atlantic Standard Time',
  'es-EC': 'Eastern Standard Time',
  'es-SV': 'Central Standard Time',
  'fr-GF': 'SA Eastern Standard Time',
  'es-GT': 'Central Standard Time',
  'en-GY': 'Atlantic Standard Time',
  'fr-HT': 'Eastern Standard Time',
  'es-HN': 'Central Standard Time',
  'fr-MQ': 'Atlantic Standard Time',
  'en-MS': 'Atlantic Standard Time',
  'es-PA': 'Eastern Standard Time',
  'es-PY': 'SA Eastern Standard Time',
  'es-PR': 'Atlantic Standard Time',
  'en-TT': 'Atlantic Standard Time',
  'es-UY': 'SA Eastern Standard Time',
  'en-BD': 'Bangladesh Standard Time',
  'en-BN': 'China Standard Time',
  'en-FJ': 'Fiji Standard Time',
  'fr-PF': 'Hawaiian Standard Time',
  'en-GU': 'E. Australia Standard Time',
  'en-MV': 'West Asia Standard Time',
  'en-MN': 'Ulaanbaatar Standard Time',
  'en-NP': 'Nepal Standard Time',
  'fr-NC': 'Central Pacific Standard Time',
  'en-PG': 'E. Australia Standard Time',
  'en-LK': 'India Standard Time',
  'fr-CD': 'W. Central Africa Standard Time',
  'en-ET': 'E. Africa Standard Time',
  'fr-GN': 'Greenwich Standard Time',
  'en-LS': 'South Africa Standard Time',
  'fr-MG': 'E. Africa Standard Time',
  'en-MW': 'South Africa Standard Time',
  'fr-MR': 'Greenwich Standard Time',
  'en-MU': 'Mauritius Standard Time',
  'en-NA': 'Namibia Standard Time',
  'en-NG': 'W. Central Africa Standard Time',
  'fr-RE': 'Mauritius Standard Time',
  'en-SC': 'Mauritius Standard Time',
  'en-TZ': 'E. Africa Standard Time',
  'en-GM': 'Greenwich Standard Time',
  'fr-TG': 'Greenwich Standard Time',
  'en-ZW': 'South Africa Standard Time',
  'fr-DZ': 'W. Central Africa Standard Time',
  'en-AM': 'Caucasus Standard Time',
  'en-AZ': 'Azerbaijan Standard Time',
  'en-BH': 'Arab Standard Time',
  'en-EG': 'Egypt Standard Time',
  'en-GE': 'Georgian Standard Time',
  'en-IQ': 'Arabic Standard Time',
  'he-IL': 'Israel Standard Time',
  'en-KG': 'Central Asia Standard Time',
  'en-LY': 'E. Europe Standard Time',
  'en-MD': 'GTB Standard Time',
  'en-OM': 'Arabian Standard Time',
  'en-PK': 'Pakistan Standard Time',
  'en-QA': 'Arab Standard Time',
  'en-TJ': 'West Asia Standard Time',
  'en-AE': 'Arabian Standard Time',
  'ar-YE': 'Arab Standard Time',
  'sq-AL': 'Central European Standard Time',
  'pt-BR': 'E. South America Standard Time',
  'sr-RS': 'Central European Standard Time',
  'bs-BA': 'Central European Standard Time',
  'mk-MK': 'Central European Standard Time',
  'sr-ME': 'Central European Standard Time',
  'is-IS': 'GMT Standard Time',
  'es-CL': 'Pacific SA Standard Time',
  'es-CO': 'SA Pacific Standard Time',
  'es-MX': 'Central Standard Time',
  'es-VE': 'Venezuela Standard Time',
  'en-ID': 'SE Asia Standard Time',
  'en-MY': 'Singapore Standard Time',
  'en-PH': 'Singapore Standard Time',
  'en-NZ': 'New Zealand Standard Time',
  'en-SG': 'Singapore Standard Time',
  'en-TH': 'SE Asia Standard Time',
  'en-VN': 'SE Asia Standard Time',
  'zh-HK': 'China Standard Time',
  'zh-TW': 'China Standard Time',
  'es-US': 'Pacific Standard Time',
  'fr-CA': 'Pacific Standard Time',
  'en-AD': 'Pacific Standard Time',
  'en-AT': 'Central European Standard Time',
  'en-BG': 'Pacific Standard Time',
  'en-CZ': 'Pacific Standard Time',
  'en-DE': 'Central European Standard Time',
  'en-DK': 'Pacific Standard Time',
  'en-EE': 'Pacific Standard Time',
  'en-ES': 'Central European Standard Time',
  'en-FI': 'Pacific Standard Time',
  'en-IT': 'Central European Standard Time',
  'en-LI': 'Pacific Standard Time',
  'en-LU': 'Pacific Standard Time',
  'en-MC': 'Pacific Standard Time',
  'en-ME': 'Central European Standard Time',
  'en-MK': 'Central European Standard Time',
  'en-MT': 'Pacific Standard Time',
  'en-NL': 'Central European Standard Time',
  'en-NO': 'Pacific Standard Time',
  'en-PT': 'Pacific Standard Time',
  'en-RO': 'Pacific Standard Time',
  'en-RS': 'Central European Standard Time',
  'en-SE': 'Central European Standard Time',
  'en-TR': 'Pacific Standard Time',
  'en-VA': 'Pacific Standard Time',
  'en-CL': 'Pacific SA Standard Time',
  'en-TG': 'Greenwich Standard Time',
  'en-YE': 'Arab Standard Time',
  'en-PF': 'Hawaiian Standard Time',
  'en-HN': 'Central Standard Time',
  'en-JP': 'Pacific Standard Time',
  'en-CD': 'W. Central Africa Standard Time',
  'en-BO': 'Atlantic Standard Time',
  'en-IL': 'Israel Standard Time',
  'en-NC': 'Central Pacific Standard Time',
  'en-GN': 'Greenwich Standard Time',
  'en-PA': 'Eastern Standard Time',
  'en-PY': 'SA Eastern Standard Time',
  'en-PR': 'Atlantic Standard Time',
  'en-HT': 'Eastern Standard Time',
  'en-MQ': 'Atlantic Standard Time',
  'en-BR': 'E. South America Standard Time',
  'en-CO': 'SA Pacific Standard Time',
  'en-VE': 'Venezuela Standard Time',
  'en-SV': 'Central Standard Time',
  'en-MG': 'E. Africa Standard Time',
  'en-MR': 'Greenwich Standard Time',
  'en-HK': 'China Standard Time',
  'en-TW': 'China Standard Time',
  'en-GF': 'SA Eastern Standard Time',
  'en-AR': 'Argentina Standard Time',
  'en-SA': 'Arab Standard Time',
  'en-PE': 'SA Pacific Standard Time',
};

const FREQUENCY_NOW = '4';

const SampleFileURLs = {
    FeedSampleFile: 'https://mmccommon.z22.web.core.windows.net/Sample_Files/mmc_example_feed.txt',
};

export const constants = {
  Frequency,
  DefaultTimeZone,
  FREQUENCY_NOW,
  SampleFileURLs,
};


export const ImportOrigin = {
  Google: 1,
  Shopify: 2,
  // Dynamics: 3,
  Bigcommerce: 4,
  PrestasShop: 5,
};

export const FeedType = {
  // Note: PrimaryFeed's MT key is also OfferFeed, whose distinguish way is whether ShowDestinations is true
  PrimaryFeed: 'PrimaryFeed',
  OfferFeed: 'OfferFeed',
  LocalProduct: 'LocalProduct',
  LocalProductInventory: 'LocalProductInventory',
  LocalProductInventoryUpdate: 'LocalProductInventoryUpdate',
  ProductUpdateFeed: 'ProductUpdateFeed',
  CoOpLinkFeed: 'CoOpLinkFeed',
  CoOpFeed: 'CoOpFeed',
  SupplementalFeed: 'SupplementalFeed',
  ProductCollections: 'ProductCollections',
};
